module.exports = new __parcel__URL__("step_two_vector_dark.ded2e120.png").toString();